import React, {useEffect, useState} from 'react';
import '../App.css';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import Bodyheaderloged from './bodyheaderloged'


function Bodyminuta (props){

    const [urlminuta, setUrlMinuta] = useState()

    const GetMinuta = () =>
    {
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLDOWNLOADFILE, {
            params: {
                casino_id: idcasino.replace('"', ''),
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setUrlMinuta(response.data.UrlFile)
        }).catch(error => {
            return error     
        })
    }

    useEffect(() => {
        GetMinuta()
    }, []);

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='flex justify-start w-full'>
                <div className='w-full'>
                    <div className="bg-white rounded-lg shadow-lg p-6 mx-4 mb-2">
                        <h2 className="text-xl font-semibold mb-4">Minuta del dia</h2>                    

                        <object width="100%" height="800" data={urlminuta} type="application/pdf">
                            {" "}
                        </object>
                    </div>
                </div>
            </div>
        </div>            
    )
}
export default Bodyminuta